/**
 * Because you can't just send `file` as json, you have to send it
 * as FormData to do the whole multipart form data binary upload
 */
export function toFormData<P extends object>(payload: P): FormData {
    const formData = new FormData();
    const keys = Object.keys(payload);
    for (const key of keys) {
        formData.set(key, payload[key]);
    }

    return formData;
}
